import React, { useState, useEffect } from "react";
import { object } from "prop-types";
import { useDeviceType } from "../../../customHooks/useDeviceType";

import "./table.m.css";

const Table = ({ element }) => {
  const [data, setData] = useState([]);
  const [displayedRows, setDisplayedRows] = useState(5);
  const isMobile = useDeviceType() === "mobile";

  useEffect(() => {
    const parseCsvData = (element) => {
      if (!element?.data?.content) return;

      const content = element.data.content.trim();
      const hasHeader = element.metadata["has-header"];
      const parseRow = (row) => {
        const cells = [];
        let currentCell = "";
        let inQuotes = false;
        for (let i = 0; i < row.length; i++) {
          const char = row[i];
          if (char === '"' && (i === 0 || row[i - 1] !== "\\")) {
            inQuotes = !inQuotes;
          } else if (char === "," && !inQuotes) {
            cells.push(currentCell.trim());
            currentCell = "";
          } else {
            currentCell += char;
          }
        }
        if (currentCell || row[row.length - 1] === ",") {
          cells.push(currentCell.trim());
        }
        return cells;
      };
      const rows = content.split("\n").map(parseRow);
      const parsedData = hasHeader
        ? {
            header: rows[0],
            body: rows.slice(1),
          }
        : {
            header: rows[0].map((_, i) => `Column ${i + 1}`),
            body: rows,
          };

      setData(parsedData);
    };

    parseCsvData(element);
  }, [element]);

  const handleLoadMore = () => setDisplayedRows((prev) => prev + 5);

  return (
    <div styleName="table-container">
      <div styleName="scroll-table">
        {data.header && (
          <table styleName="responsive-table" align="center">
            {element.metadata["has-header"] && (
              <thead>
                <tr>
                  {data.header.map((col, index) => (
                    <th key={index}>{col}</th>
                  ))}
                </tr>
              </thead>
            )}
            <tbody>
              {data.body.slice(0, isMobile ? displayedRows : data.body.length).map((row, index) => (
                <tr key={index}>
                  {row.map((cell, i) => (
                    <td style={{ textWrap: "wrap" }} key={i}>
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {isMobile && displayedRows < data.body?.length && (
        <button styleName="load-more-btn" onClick={handleLoadMore}>
          Load More
        </button>
      )}
    </div>
  );
};

Table.propTypes = {
  element: object,
};

export default Table;
